/* eslint-disable no-unsafe-optional-chaining */
import { Box, Text } from "@quintoandar-tokko/jopijs";
import { useEffect, useRef, useState } from "react";
import style from "./tooltipOperationCard.module.scss";
import translations from "../../../FichaInfo.trans.json";
import Trans from "@/components/shared/Trans";

export default function ToolTipOperationCard({ children, maxWidth = 350 }) {
  const [hover, setHover] = useState(false);
  const [position, setPosition] = useState({
    bottom: "0px",
    arrow: "0px",
  });
  const [arrowPositionX, setArrowPositionX] = useState("50%");

  const refTip = useRef(null);
  const refWind = useRef(null);
  let patherWidth = refTip.current?.offsetParent?.offsetWidth;
  const childrenWidth = refTip.current?.offsetWidth;
  const handleMouse = () => {
    if (patherWidth < 843) return;
    setHover(!hover);
  };
  const handleClose = (e) => {
    e.stopPropagation();
    setHover(false);
  };
  useEffect(() => {
    setPosition({
      ...position,
      arrow: `${(refTip.current.offsetHeight - 14) / 2}px`,
    });
    const elemWidth = refTip.current?.offsetWidth;
    const elemViewportUbic = refTip.current?.getBoundingClientRect();
    patherWidth = refTip.current?.offsetParent?.offsetWidth;
    const toolTipWidth = patherWidth < 380 ? patherWidth : maxWidth;
    const availableSpaceToRigth =
      patherWidth - elemViewportUbic.right + elemWidth / 2;
    const availableSpaceToLefth = elemViewportUbic.left + elemWidth / 2;
    if (toolTipWidth / 2 > availableSpaceToRigth) {
      const deviation =
        elemWidth / 2 + (availableSpaceToRigth - toolTipWidth / 2);
      setPosition({
        ...position,
        left: `${deviation + 16}px`,
      });
      setArrowPositionX(toolTipWidth / 2 + elemWidth / 2 - deviation);
    } else if (toolTipWidth / 2 > availableSpaceToLefth) {
      const deviation =
        elemWidth / 2 + (toolTipWidth / 2 - availableSpaceToLefth);
      setPosition({
        ...position,
        left: `${deviation - 16}px`,
      });
      setArrowPositionX(toolTipWidth / 2 + elemWidth / 2 - deviation);
    } else setPosition({ ...position, left: "50%" });
  }, [refTip.current, hover]);
  useEffect(() => {
    if (refWind.current)
      setPosition({
        ...position,
        top: `${-(refWind.current.clientHeight / 2 + 6)}px`,
      });
  }, [refWind, hover]);

  return (
    <Box
      __css={{
        position: "relative",
      }}
      onMouseEnter={handleMouse}
      onMouseLeave={handleMouse}
      onClick={() => setHover(true)}
      className={style.container}
      ref={refTip}
    >
      {children}
      {hover && (
        <Box
          ref={refWind}
          className={`${style.tip} ${style.nonOutSideModal}`}
          width={`${
            patherWidth - 32 >= childrenWidth ? "maxContent" : childrenWidth
          }`}
          style={{
            top: position?.top,
            left: position?.left,
          }}
        >
          <Text
            width="100%"
            className={style.title}
            fontWeight="700"
            fontSize="16px"
          >
            {Trans(translations, "TooltipOperationsEditionTitle")}
          </Text>
          <Text fontSize="14px">
            {" "}
            {Trans(translations, "TooltipOperationsEditionText")}.
          </Text>
          <Box className={style.accept}>
            <Text onClick={handleClose} cursor="pointer">
              {Trans(translations, "TooltipOperationsUnderstood")}
            </Text>
          </Box>
          <Box
            __css={{
              bottom: "-4px",
              left: arrowPositionX,
            }}
            className={`${style.arrow} ${style.top}`}
          />
        </Box>
      )}
    </Box>
  );
}
